import React from 'react';
import { HeroBridgeSVG } from './SVGs/WhySectionSVGs';

const AboutHero = () => {
  return (
    <section id="about" className="hero container">
      <div className="hero-grid">
        <div>
          <span className="section-header label">about</span>
          <h1 className="hero-title">ProcureForEU <span>sourcing bridge</span></h1>
          <p className="hero-subtitle">
            Founded in 2025 to close the gap between European manufacturers and production teams across Asia.
            Direct, transparent, and responsible.
          </p>
          <p className="hero-quote">Sustainability through simplification — every emission matters.</p>
          <div className="hero-tags">
            <span className="pill-tag"><i className="fas fa-leaf text-eu"></i> carbon reduction</span>
            <span className="pill-tag"><i className="fas fa-check-circle text-eu"></i> compliance</span>
            <span className="pill-tag"><i className="fas fa-globe text-eu"></i> EU standards</span>
          </div>
          <button className="btn-eu mt-4">Learn More →</button>
        </div>
        <div>
          <HeroBridgeSVG />
        </div>
      </div>
      <div className="foundation-box">
        <h3><i className="fas fa-seedling"></i> Our Foundation & Sustainability Mission</h3>
        <p>
          ProcureForEU was founded with a clear and uncompromising mission: Asia should not become a dumping ground 
          for global carbon emissions, and every emission matters because its impact is global, not local. We challenge 
          this imbalance by building a sourcing model that does not trade cost efficiency for environmental damage.
        </p>
      </div>
    </section>
  );
};

export default AboutHero;